export default "__VITE_ASSET__CsmLC_Qq__"